// https://vuex.vuejs.org/en/state.html
const getDefaultState = () => {
  return {
    idToken: null,
    userId: null,
    user: {},
    loading: false,
    currentUser: {},
    publicRoute: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 25,
      sortBy: "created_at",
      totalItems: 0,
      rowsPerPageItems: [5, 10, 25, 50, 100],
    },
    power_plants: [],
    items: [],
    consumer_units: [],
    users: [],
    leads: [],
    config: {
      users: {
        total: 0,
        ativos: 0,
        inativos: 0,
      },
      consumer_units: {
        total: 0,
        ativos: 0,
        inativos: 0,
      },
    },
    groupList: [],
    permissions: {
      cancel_parcel: false,
      cancel_uc: false,
      cancel_user: false,
      change_abono: false,
      change_bonus_uc: false,
      change_additional_balance_uc: false,
      change_due_date: false,
      change_due_date_installment: false,
      change_email: false,
      decrypt_login: false,
      download_bill: false,
      edit_customer: false,
      edit_cpf_cnpj: false,
      faturar: false,
      forced_canceling: false,
      forced_cancellation: false,
      inform_payment: false,
      invoice_by_spreadsheet: false,
      invoice_by_xml: false,
      parcel: false,
      payoff_parcel: false,
      reactivate_uc: false,
      reactivate_user: false,
      referral: false,
      remove_negativations: false,
      reparcel: false,
      reprocess_billing: false,
      resend_bill: false,
      upload_bill: false,
      uc_under_analysis: false,
      force_uc_cancellation: false,
      change_plan_uc: false,
      change_uc_id: false,
      regenerate_billing: false,
      choose_seller_in_sale: false,
      without_balance: false,
      generate_contract: false,
      charge_provisioned: false,
    },
  };
};

// initial state
const state = getDefaultState();

export default {
  getDefaultState,
  ...state,
};

// export default {
//   idToken: null,
//   userId: null,
//   user: null,
//   loading: false,
//   currentUser: null,
//   pagination: {
//     descending: true,
//     page: 1,
//     rowsPerPage: 25,
//     sortBy: 'created_at',
//     totalItems: 0,
//     rowsPerPageItems: [5, 10, 25, 50, 100]
//   },
//   items: [],
//   consumer_units: [],
//   users: [],
//   leads: [],
//   config: {
//     users: {
//       total: 0,
//       ativos: 0,
//       inativos: 0
//     },
//     consumer_units: {
//       total: 0,
//       ativos: 0,
//       inativos: 0
//     }
//   },
// }
